import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTenantConfig } from 'contexts';
import {
  Modal as MobileModal,
  ModalBody as MobileModalBody,
} from '@teko/ds-mobile';
import { Modal, ModalHeader, ModalBody } from '@teko/ds-desktop';
import { useAuth } from '@teko/auth-react';
import { t } from 'i18n';

export const WarningNoLoyaltyMemberModal: React.FC = () => {
  const {
    isMobile,
    needToShowWarningNoLoyaltyMemberInCart,
    instructionLinkForLoyaltyAccount,
  } = useTenantConfig();
  const { user, loading: isFetchingUser } = useAuth();
  const router = useRouter();

  const [showWarningNoLoyaltyMember, setShowWarningNoLoyaltyMember] =
    useState(false);

  useEffect(() => {
    if (
      needToShowWarningNoLoyaltyMemberInCart &&
      !isFetchingUser &&
      !user?.loyaltyMemberId
    ) {
      setShowWarningNoLoyaltyMember(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.loyaltyMemberId, isFetchingUser]);

  return isMobile ? (
    <MobileModal
      visible={showWarningNoLoyaltyMember}
      width="80%"
      title={t('Thông báo')}
      centeredTitle={true}
      okText={t('Xem hướng dẫn')}
      onOk={() => {
        setShowWarningNoLoyaltyMember(false);
        if (instructionLinkForLoyaltyAccount)
          router.push(instructionLinkForLoyaltyAccount);
      }}
      cancelText={t('Đóng')}
      onCancel={() => setShowWarningNoLoyaltyMember(false)}
      fullWidthFooter={true}
      showCloseIcon={false}
    >
      <MobileModalBody padding="s0">
        {t(
          'Tài khoản của Quý khách hiện chưa liên kết/đăng ký thẻ thành viên. Vui lòng liên kết/đăng ký thẻ với tài khoản mua sắm để bắt đầu tích lũy điểm và nhận các ưu đãi đặc quyền khi mua sắm online.',
        )}
      </MobileModalBody>
    </MobileModal>
  ) : (
    <Modal
      visible={showWarningNoLoyaltyMember}
      size="m"
      cancelText={t('Đóng')}
      onCancel={() => setShowWarningNoLoyaltyMember(false)}
      okText={t('Xem hướng dẫn')}
      onOk={() => {
        setShowWarningNoLoyaltyMember(false);
        window.open(instructionLinkForLoyaltyAccount, '_blank');
      }}
      showCloseIcon={false}
      alignFooter="center"
    >
      <ModalHeader padding="s0">{t('Thông báo')}</ModalHeader>
      <ModalBody paddingLeft="s0" paddingRight="s0">
        {t(
          'Tài khoản của Quý khách hiện chưa liên kết/đăng ký thẻ thành viên. Vui lòng liên kết/đăng ký thẻ với tài khoản mua sắm để bắt đầu tích lũy điểm và nhận các ưu đãi đặc quyền khi mua sắm online.',
        )}
      </ModalBody>
    </Modal>
  );
};
